import React from 'react'
import PropTypes from 'prop-types'

const ProgramContact = ({ 
  contactTitle = '',
  contactEmail = '',
  contactName = '',
}) => {
  if (!contactTitle || !contactEmail || !contactName) {
    return null
  }
  return <>
    <div className={'program-contact-title'}>
      <h5 className={'heading-5 mb-0'} style={{ color: '#000000' }}>{contactName}</h5>
      <span className={'body-text mb-0'} style={{ textTransform: 'capitalize' }}>{contactTitle}</span><br/>
      <span className={'body-text mb-0'}>Email: <a href={`mailto:${contactEmail}`}>{contactEmail}</a></span>
      
    </div>
  </>
}

ProgramContact.propTypes = {
  contactTitle : PropTypes.string,
  contactEmail : PropTypes.string,
  contactName  : PropTypes.string
}

export default React.memo(ProgramContact)